import axios from 'axios';
import prepareRequestOptions from '../utils/admin-apis.util';

export const getListData = async (params = '') => {
  const options = prepareRequestOptions(
    `/admin/quiz/list${params}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const createNewData = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/quiz/create',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const viewDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/quiz/${id}/view`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateDataById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/quiz/${id}/update`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const toggleQuizStatus = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/quiz/${payload.id}/status/toggle`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/quiz/${id}/delete`,
    'DELETE',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getQuestionsByQuizId = async (id) => {
  const options = prepareRequestOptions(
    `/admin/quiz/${id}/questions`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getQuizQuestionById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/quiz/question/${id}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const saveQuizQuestionDetail = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/quiz/manage-question',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteQuizQuestionById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/quiz/question/${id}/delete`,
    'DELETE',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteQuizQuestionOptionById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/quiz/question/option/${id}/delete`,
    'DELETE',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const manageQuizQuestionsSequence = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/quiz/questions/manage-sequence',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getSubscriberAttemptDetails = async (id, params = '') => {
  const options = prepareRequestOptions(
    `/admin/quiz/${id}/subscriber-attempts${params}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getQuizResultsBySubscriberId = async (
  id,
  subscriberId,
  output = 'json'
) => {
  const options = prepareRequestOptions(
    `/admin/quiz/${id}/subscriber/${subscriberId}/attempts?output=${output}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getQuizDetailBySubscriberId = async (id, subId) => {
  const options = prepareRequestOptions(
    `/admin/quiz/${id}/subscriber/${subId}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};
